import React, { Component } from "react";
import TableReactExtends from "../../../Components/TableReactExtends";
import ProyectoLeyDataService from "../../../Services/Congreso/ProyectoLey.Service";
import Spinner from "../../../Components/Spinner";
import Select from "../../../Components/Select";
import ValidForm from "../../../Utils/ValidForm";
import { ModuloPermiso } from "../../../Permisos/ModuloPermiso";
import ValidarPermiso from "../../../Permisos/ValidarPermiso";
import UtilsDataService from "../../../Services/General/Utils.Service";

const validForm = new ValidForm();
const fieldsConst = {
    id: 0,
    titulo: "",
    activo: false,
};
const errorsConst = {
    id: "",
    titulo: "",
    activo: "",
};

const SelectTipo = { value: -1, label: 'Filtrar por tipo' };
const SelectEstado = { value: -1, label: 'Filtrar por estado' };
const SelectIniciativa = { value: -1, label: 'Filtrar por iniciativa' };
const SelectTema = { value: -1, label: 'Filtrar por tema' };
const SelectLegislatura = { value: -1, label: 'Filtrar por legislatura' };
const SelectCuatrienio = { value: -1, label: 'Filtrar por cuatrienio' };

class ProyectoLeys extends Component {
    constructor(props) {
        super(props);

        this.tableHandler = this.tableHandler.bind(this);

        this.state = {
            tableInfo: {
                columns: [
                    {
                        Header: "Proyectos de ley",
                        columns: [
                            {
                                Header: "id",
                                accessor: "id",
                            },
                            {
                                Header: "Título",
                                accessor: "titulo",
                            },
                            {
                                Header: "Legislatura",
                                accessor: "legislatura.nombre",
                            },
                            {
                                Header: "Cuatrienio",
                                accessor: "cuatrienio.nombre",
                            },
                            {
                                Header: "Tipo de proyecto",
                                accessor: "tipo_proyecto_ley.nombre",
                            },
                            {
                                Header: "Activo",
                                id: "activo",
                                accessor: "activo",
                                Cell: (tableProps) => {
                                    return (
                                        <input
                                            type="checkbox"
                                            className="icheckbox"
                                            checked={
                                                tableProps.row.values.activo
                                            }
                                            readOnly
                                        />
                                    );
                                },
                            },
                            {
                                Header: "Número en cámara",
                                accessor: "numero_camara",
                            },
                            {
                                Header: "Número en senado",
                                accessor: "numero_senado",
                            },
                        ],
                    },
                    {
                        Header: "Acciones",
                        columns: [
                            {
                                Header: "Editar",
                                id: "editar",
                                accessor: (str) => "editar",
                                Cell: (tableProps) => (
                                    <ValidarPermiso
                                        IdModuloPermisoValidar={ModuloPermiso.CargoIntegrante.Obtener}
                                        DefaultTemplate=
                                        {
                                            <a
                                                href={`#/proyecto-ley-editar/${tableProps.row.values.id}`}
                                                data-id={tableProps.row.values.id}
                                                className="btn btn-info btn-block"
                                            >
                                                <i className="fa fa-edit"></i> Editar
                                            </a>
                                        }
                                    />
                                ),
                            },
                            {
                                Header: "Activar/Desactivar",
                                id: "actdesc",
                                accessor: (str) => "actdesc",
                                Cell: (tableProps) => (
                                    <ValidarPermiso
                                        IdModuloPermisoValidar={ModuloPermiso.ProyectoDeLey.Eliminar}
                                        DefaultTemplate=
                                        {
                                            <button
                                                data-toggle="modal"
                                                data-target="#modal-activar-desactivar"
                                                className={`btn ${tableProps.row.values.activo === 1
                                                    ? "btn-danger"
                                                    : "btn-warning"} eliminar`}
                                                style={{ width: "100%" }}
                                                data-id={tableProps.row.values.id}
                                                onClick={() => {
                                                    this.handlerDesactivar(
                                                        tableProps.row.values
                                                    );
                                                }}
                                            >
                                                <i className="fa fa-eraser"></i>{" "}
                                                {tableProps.row.values.activo === 1
                                                    ? "Desactivar"
                                                    : "Activar"}
                                            </button>
                                        }
                                    />

                                ),
                            },
                        ],
                    },
                ],
                hiddenColumns: ["id", "activo"],
                data: [],
                page: 1,
                rows: 15,
                search: "",
                totalRows: 0,
            },
            fields: fieldsConst,
            errors: errorsConst,
            loading: true,
            filterActive: { value: 1, label: "Activo" },
            dataSelectActive: [
                { value: -1, label: "Filtrar por activo" },
                { value: 1, label: "Activo" },
                { value: 0, label: "Inactivo" },
            ],
            filterTipo: SelectTipo,
            dataSelectTipo: [],
            filterEstado: SelectEstado,
            dataSelectEstado: [],
            filterIniciativa: SelectIniciativa,
            dataSelectIniciativa: [],
            filterTema: SelectTema,
            dataSelectTema: [],
            filterCuatrienio: SelectCuatrienio,
            dataSelectCuatrienio: [],
            filterLegislatura: SelectLegislatura,
            dataSelectLegislatura: [],
        };
    }
    async tableHandler(page, rows, search, isDelay) {
        let delayAccion = isDelay ? 1000 : 0;
        let tableInfo = this.state.tableInfo;
        tableInfo.page = page;
        tableInfo.rows = rows;
        tableInfo.search = search;
        if (!isDelay) tableInfo.data = [];
        this.setState({ tableInfo: tableInfo });
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(
            async function () {
                await this.getAll(
                    this.state.filterActive.value,
                    this.state.filterTipo.value,
                    this.state.filterEstado.value,
                    this.state.filterIniciativa.value,
                    this.state.filterTema.value,
                    this.state.filterCuatrienio.value,
                    this.state.filterLegislatura.value,
                    page,
                    rows,
                    search
                );
            }.bind(this),
            delayAccion
        );
    }

    handleFilterLegislatura = async (selectLegislatura) => {
        this.setState({ filterLegislatura: selectLegislatura }, async () => {
            await this.getAll(
                this.state.filterActive.value,
                this.state.filterTipo.value,
                this.state.filterEstado.value,
                this.state.filterIniciativa.value,
                this.state.filterTema.value,
                this.state.filterCuatrienio.value,
                selectLegislatura.value,
                1,
                this.state.tableInfo["rows"],
                this.state.tableInfo["search"]
            );
        });
    };

    handleFilterCuatrienio = async (selectCuatrienio) => {
        this.setState({ filterCuatrienio: selectCuatrienio, filterLegislatura: Object.assign({}, SelectLegislatura), dataSelectLegislatura: [] }, async () => {
            await this.getAll(
                this.state.filterActive.value,
                this.state.filterTipo.value,
                this.state.filterEstado.value,
                this.state.filterIniciativa.value,
                this.state.filterTema.value,
                selectCuatrienio.value,
                -1,
                1,
                this.state.tableInfo["rows"],
                this.state.tableInfo["search"]
            );
            await this.getComboLegislatura(selectCuatrienio.value);
        });
    };

    handleFilterTema = async (selectTema) => {
        this.setState({ filterTema: selectTema }, async () => {
            await this.getAll(
                this.state.filterActive.value,
                this.state.filterTipo.value,
                this.state.filterEstado.value,
                this.state.filterIniciativa.value,
                selectTema.value,
                this.state.filterCuatrienio.value,
                this.state.filterLegislatura.value,
                1,
                this.state.tableInfo["rows"],
                this.state.tableInfo["search"]
            );
        });
    };

    handleFilterIniciativa = async (selectIniciativa) => {
        this.setState({ filterIniciativa: selectIniciativa }, async () => {
            await this.getAll(
                this.state.filterActive.value,
                this.state.filterTipo.value,
                this.state.filterEstado.value,
                selectIniciativa.value,
                this.state.filterTema.value,
                this.state.filterCuatrienio.value,
                this.state.filterLegislatura.value,
                1,
                this.state.tableInfo["rows"],
                this.state.tableInfo["search"]
            );
        });
    };

    handleFilterEstado = async (selectEstado) => {
        this.setState({ filterEstado: selectEstado }, async () => {
            await this.getAll(
                this.state.filterActive.value,
                this.state.filterTipo.value,
                selectEstado.value,
                this.state.filterIniciativa.value,
                this.state.filterTema.value,
                this.state.filterCuatrienio.value,
                this.state.filterLegislatura.value,
                1,
                this.state.tableInfo["rows"],
                this.state.tableInfo["search"]
            );
        });
    };

    handleFilterTipo = async (selectTipo) => {
        this.setState({ filterTipo: selectTipo }, async () => {
            await this.getAll(
                this.state.filterActive.value,
                selectTipo.value,
                this.state.filterEstado.value,
                this.state.filterIniciativa.value,
                this.state.filterTema.value,
                this.state.filterCuatrienio.value,
                this.state.filterLegislatura.value,
                1,
                this.state.tableInfo["rows"],
                this.state.tableInfo["search"]
            );
        });
    };

    async componentDidMount() {
        await this.getAll(
            this.state.filterActive.value,
            this.state.filterTipo.value,
            this.state.filterEstado.value,
            this.state.filterIniciativa.value,
            this.state.filterTema.value,
            this.state.filterCuatrienio.value,
            this.state.filterLegislatura.value,
            this.state.tableInfo["page"],
            this.state.tableInfo["rows"],
            this.state.tableInfo["search"]
        );
        await this.getComboTipo();
        await this.getComboEstado();
        await this.getComboIniciativa();
        await this.getComboTema();
        await this.getComboCuatrienio();
    }

    getComboCuatrienio = async () => {
        this.setState({ loading: true });
        await UtilsDataService.getComboCuatrienio().then((response) => {
            let combo = [];
            response.data.forEach((i) => {
                combo.push({ value: i.id, label: i.nombre });
            });
            combo.unshift({ value: -1, label: "Filtrar por cuatrienio" });
            this.setState({
                dataSelectCuatrienio: combo,
                loading: false,
            });
        });
    };

    getComboLegislatura = async (cuatrienio_id) => {

        let cuatrienio_ids = [];
        if (cuatrienio_id) {
            if (Array.isArray(cuatrienio_id)) {
                for (let i = 0; i < cuatrienio_id.length; i++) {
                    cuatrienio_ids.push(cuatrienio_id[i]);
                }
            } else {
                cuatrienio_ids.push(cuatrienio_id);
            }

            cuatrienio_ids = JSON.stringify(cuatrienio_ids);
        }
        await UtilsDataService.getComboLegislaturaFilter({cuatrienio_id: cuatrienio_ids})
            .then(response => {
                this.setState({ loading: true });
                let combo = [];
                response.data.forEach(i => {
                    combo.push({ value: i.id, label: i.nombre })
                })
                combo.unshift({ value: -1, label: "Filtrar por legislatura" })
                this.setState({
                    dataSelectLegislatura: combo,
                    loading: false
                })
            });
    }

    getComboTema = async () => {
        await UtilsDataService.getComboTemaFilter()
            .then(response => {
                this.setState({ loading: true });
                let combo = [];
                response.data.forEach(i => {
                    combo.push({ value: i.id, label: i.nombre })
                })
                combo.unshift({ value: -1, label: "Filtrar por tema" })
                this.setState({
                    dataSelectTema: combo,
                    loading: false
                })
            });
    }

    getComboIniciativa = async () => {
        await UtilsDataService.getComboIniciativaFilter()
            .then(response => {
                this.setState({ loading: true });
                let combo = [];
                response.data.forEach(i => {
                    combo.push({ value: i.id, label: i.nombre })
                })
                combo.unshift({ value: -1, label: "Filtrar por iniciativa" })
                this.setState({
                    dataSelectIniciativa: combo,
                    loading: false
                })
            });
    }

    getComboEstado = async () => {
        await UtilsDataService.getComboEstadoProyecto()
            .then(response => {
                this.setState({ loading: true });
                let combo = [];
                response.data.forEach(i => {
                    combo.push({ value: i.id, label: i.nombre })
                })
                combo.unshift({ value: -1, label: "Filtrar por estado" })
                this.setState({
                    dataSelectEstado: combo,
                    loading: false
                })
            });
    }

    getComboTipo = async () => {
        await UtilsDataService.getComboTipoProyecto()
            .then(response => {
                this.setState({ loading: true });
                let combo = [];
                response.data.forEach(i => {
                    combo.push({ value: i.id, label: i.nombre })
                })
                combo.unshift({ value: -1, label: "Filtrar por tipo" })
                this.setState({
                    dataSelectTipo: combo,
                    loading: false
                })
            });
    }

    handlerDesactivar = (item) => {
        let desActObj = {
            id: item.id,
            titulo: item.titulo,
            activo: item.activo,
        };
        this.setState({
            fields: desActObj,
        });
    };

    deleteSubmit = async (e) => {
        e.preventDefault();
        let errors = this.state.errors;
        errors = validForm.cleanErrors(errors);
        this.setState({ errors: errors, loading: true });

        let responseData;
        await ProyectoLeyDataService.delete(this.state.fields["id"])
            .then((response) => {
                responseData = response.data;
            })
            .catch(function (error) {
                errors = validForm.displayErrors(
                    error.response.data.errors,
                    errors
                );
            });

        this.setState({ errors: errors, loading: false });
        if (responseData != null) {
            await this.getAll(
                this.state.filterActive.value,
                this.state.filterTipo.value,
                this.state.filterEstado.value,
                this.state.filterIniciativa.value,
                this.state.filterTema.value,
                this.state.filterCuatrienio.value,
                this.state.filterLegislatura.value,
                this.state.tableInfo["page"],
                this.state.tableInfo["rows"],
                this.state.tableInfo["search"]
            );
            document.querySelector(`#modal-activar-desactivar button[data-dismiss="modal"]`).click();
        }
    };

    getAll = async (idFilterActive, tipo, estado, iniciativa, tema, cuatrienio, legislatura, page, rows, search) => {
        this.setState({ loading: true });
        let tableInfo = this.state.tableInfo;
        tableInfo.page = page;
        await ProyectoLeyDataService.getAll(idFilterActive, tipo, estado, iniciativa, tema, legislatura, search, page, rows, cuatrienio)
            .then((response) => {
                tableInfo["data"] = response.data;
            })
            .catch((e) => {
                console.log(e);
            });

        await ProyectoLeyDataService.getTotalRecords(idFilterActive, tipo, estado, iniciativa, tema, legislatura, search, cuatrienio)
            .then((response) => {
                tableInfo["totalRows"] = response.data;
            })
            .catch((e) => {
                console.log(e);
            });

        this.setState({
            tableInfo: tableInfo,
            loading: false,
        });
    };

    resetFiels() {
        let fields = validForm.resetObject(fieldsConst);
        this.setState({
            fields: fields,
            errors: validForm.cleanErrors(this.state.errors),
        });
    }

    handleFilterActive = async (selectActive) => {
        this.setState({ filterActive: selectActive }, async () => {
            await this.getAll(
                selectActive.value,
                this.state.filterTipo.value,
                this.state.filterEstado.value,
                this.state.filterIniciativa.value,
                this.state.filterTema.value,
                this.state.filterCuatrienio.value,
                this.state.filterLegislatura.value,
                this.state.tableInfo.page,
                this.state.tableInfo.rows,
                this.state.tableInfo.search
            );
        });
    };
    render() {
        return (
            <div>
                <Spinner show={this.state.loading} />

                <div className={`message-box message-box-${this.state.fields.activo ? "danger" : "info"} animated fadeIn`} id="modal-activar-desactivar">
                    <form>
                        <div className="mb-container">
                            <div className="mb-middle">
                                <div className="mb-title"><span className={`fa fa-${this.state.fields.activo ? "eraser" : "check"}`}></span> {this.state.fields.activo ? "Desactivar" : "Activar"} proyecto de ley</div>
                                <div className="mb-content">
                                    <p>{`¿Está seguro que desea ${this.state.fields.activo ? "desactivar" : "activar"} el proyecto de ley ${this.state.fields.titulo}? Puede volver a ${this.state.fields.activo ? "activarlo" : "desactivarlo"} en cualquier otro momento.`}</p>
                                </div>
                                <div className="mb-footer">
                                    <ValidarPermiso
                                        IdModuloPermisoValidar={ModuloPermiso.ProyectoDeLey.Eliminar}
                                        DefaultTemplate=
                                        {
                                            <button type="button" className="btn btn-primary btn-lg pull-right" onClick={async (e) => { await this.deleteSubmit(e) }} >{this.state.fields.activo ? "Desactivar" : "Activar"}</button>
                                        }
                                    />
                                    &nbsp;
                                    <button className="btn btn-default btn-lg pull-right" type="button" data-dismiss="modal">Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <ul className="breadcrumb push-down-0">
                    <li>
                        <a href="/">Proyectos de ley</a>
                    </li>
                </ul>
                <div className="content-frame">
                    <div className="content-frame-top">
                        <div className="rowListado">
                            <div className="panel panel-default ">
                                <div className="panel-heading">
                                    <h3 className="panel-title">
                                        <span className="fa fa-list"></span>{" "}
                                        Listado de proyectos de ley
                                    </h3>
                                    <ul className="panel-controls">
                                        <li>
                                            <div style={{ minWidth: "150px" }}>
                                                <Select
                                                    divClass=""
                                                    selectplaceholder="Seleccione"
                                                    selectValue={this.state.filterCuatrienio}
                                                    selectOnchange={this.handleFilterCuatrienio}
                                                    selectoptions={this.state.dataSelectCuatrienio}
                                                    selectIsSearchable={true}
                                                    selectclassNamePrefix="selectReact__value-container"
                                                    spanClass=""
                                                    spanError=""
                                                />
                                            </div>
                                        </li>
                                        <li>
                                            <div style={{ minWidth: "150px" }}>
                                                <Select
                                                    divClass=""
                                                    selectplaceholder="Seleccione"
                                                    selectValue={this.state.filterLegislatura}
                                                    selectOnchange={this.handleFilterLegislatura}
                                                    selectoptions={this.state.dataSelectLegislatura}
                                                    selectIsSearchable={true}
                                                    selectclassNamePrefix="selectReact__value-container"
                                                    noOptionsMessage="Debe seleccionar un cuatrienio"
                                                    spanClass=""
                                                    spanError=""
                                                />
                                            </div>
                                        </li>
                                        <li>
                                            <div style={{ minWidth: "150px" }}>
                                                <Select
                                                    divClass=""
                                                    selectplaceholder="Seleccione"
                                                    selectValue={
                                                        this.state.filterTema
                                                    }
                                                    selectOnchange={
                                                        this.handleFilterTema
                                                    }
                                                    selectoptions={
                                                        this.state.dataSelectTema
                                                    }
                                                    selectIsSearchable={true}
                                                    selectclassNamePrefix="selectReact__value-container"
                                                    spanClass=""
                                                    spanError=""
                                                />
                                            </div>
                                        </li>
                                        <li>
                                            <div style={{ minWidth: "150px" }}>
                                                <Select
                                                    divClass=""
                                                    selectplaceholder="Seleccione"
                                                    selectValue={
                                                        this.state.filterTipo
                                                    }
                                                    selectOnchange={
                                                        this.handleFilterTipo
                                                    }
                                                    selectoptions={
                                                        this.state.dataSelectTipo
                                                    }
                                                    selectIsSearchable={true}
                                                    selectclassNamePrefix="selectReact__value-container"
                                                    spanClass=""
                                                    spanError=""
                                                />
                                            </div>
                                        </li>
                                        <li>
                                            <div style={{ minWidth: "150px" }}>
                                                <Select
                                                    divClass=""
                                                    selectplaceholder="Seleccione"
                                                    selectValue={
                                                        this.state.filterEstado
                                                    }
                                                    selectOnchange={
                                                        this.handleFilterEstado
                                                    }
                                                    selectoptions={
                                                        this.state.dataSelectEstado
                                                    }
                                                    selectIsSearchable={true}
                                                    selectclassNamePrefix="selectReact__value-container"
                                                    spanClass=""
                                                    spanError=""
                                                />
                                            </div>
                                        </li>
                                        <li>
                                            <div style={{ minWidth: "150px" }}>
                                                <Select
                                                    divClass=""
                                                    selectplaceholder="Seleccione"
                                                    selectValue={
                                                        this.state.filterIniciativa
                                                    }
                                                    selectOnchange={
                                                        this.handleFilterIniciativa
                                                    }
                                                    selectoptions={
                                                        this.state.dataSelectIniciativa
                                                    }
                                                    selectIsSearchable={true}
                                                    selectclassNamePrefix="selectReact__value-container"
                                                    spanClass=""
                                                    spanError=""
                                                />
                                            </div>
                                        </li>
                                        <li>
                                            <div style={{ minWidth: "90px" }}>
                                                <Select
                                                    divClass=""
                                                    selectplaceholder="Seleccione"
                                                    selectValue={
                                                        this.state.filterActive
                                                    }
                                                    selectOnchange={
                                                        this.handleFilterActive
                                                    }
                                                    selectoptions={
                                                        this.state
                                                            .dataSelectActive
                                                    }
                                                    selectIsSearchable={true}
                                                    selectclassNamePrefix="selectReact__value-container"
                                                    spanClass=""
                                                    spanError=""
                                                />
                                            </div>
                                        </li>
                                        <li>
                                            <ValidarPermiso
                                                IdModuloPermisoValidar={ModuloPermiso.ProyectoDeLey.Nuevo}
                                                DefaultTemplate=
                                                {
                                                    <a
                                                        href="#/proyecto-ley-crear"
                                                        className="btn btn-primary"
                                                    >
                                                        <i className="fa fa-plus"></i>{" "}
                                                        Nuevo registro
                                                    </a>
                                                }
                                            />
                                        </li>
                                    </ul>
                                </div>
                                <div className="panel-body">
                                    <div>
                                        <ValidarPermiso
                                            IdModuloPermisoValidar={ModuloPermiso.ProyectoDeLey.ObtenerTodos}
                                            DefaultTemplate=
                                            {
                                                <TableReactExtends
                                                    columns={
                                                        this.state.tableInfo["columns"]
                                                    }
                                                    data={this.state.tableInfo["data"]}
                                                    hiddenColumns={
                                                        this.state.tableInfo[
                                                        "hiddenColumns"
                                                        ]
                                                    }
                                                    handler={this.tableHandler}
                                                    pageExtends={
                                                        this.state.tableInfo["page"]
                                                    }
                                                    totalRows={
                                                        this.state.tableInfo[
                                                        "totalRows"
                                                        ]
                                                    }
                                                    search={
                                                        this.state.tableInfo["search"]
                                                    }
                                                />
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProyectoLeys;
